<template>
  <div>
    <div class="card w-full mt-2 border border-primary-500">
      <div class="flex justify-between items-center">
        <p class="font-medium">
          Semana #{{ index }}
        </p>

        <button
          class="button-interactive flex items-center system-button"
          @click.prevent="mealSet.collapsed = !mealSet.collapsed"
        >
          <span class="text-sm mr-2">{{
            mealSet.collapsed ? "Ver detalle completo" : "Colapsar"
          }}</span>
          <arrow-icon
            class="w-3 smooth"
            :class="[{ '-rotate-90': mealSet.collapsed }]"
          />
        </button>
      </div>

      <div v-show="!mealSet.collapsed">
        <div class="div-line"></div>

        <div class="mt-2 text-sm">
          <p class="font-medium">Cantidad total</p>
          <p>{{ (mealSet.total_quantity).toLocaleString() }}g</p>
        </div>

        <!-- <div class="mt-2 text-sm">
          <p class="font-medium">Comentarios</p>
          <p>{{ mealSet.comments }}</p>
        </div> -->

        <div class="mt-2 text-sm">
          <button
            v-if="editEnabled"
            class="secondary-button"
            @click.prevent="$emit('edit')"
          >
            Editar
          </button>

          <p class="font-medium mt-4">Comidas</p>

          <div
            v-for="(meal, i) in mealSet.meals"
            :key="meal.id"
            class="card w-full mt-2 border border-secondary-500"
          >
            <p>Comida #{{ i + 1 }}</p>

            <div class="flex flex-wrap">
              <div
                v-for="(portion, j) in meal.portions"
                :key="portion.id"
                class="card mt-2 mr-2 border border-tertiary-500"
              >
                <p>Porción #{{ j + 1 }}</p>
                <div class="mt-2 text-sm">
                  <p class="font-medium">Categoría</p>
                  <p>
                    {{ portion.diet_subcategory.diet_category.name }}
                  </p>
                </div>

                <div class="mt-2 text-sm">
                  <p class="font-medium">Subcategoría</p>
                  <p>{{ portion.diet_subcategory.name }}</p>
                </div>

                <div class="mt-2 text-sm">
                  <p class="font-medium">Cantidad</p>
                  <p>{{ portion.quantity.toLocaleString() }}g</p>
                </div>
              </div>
            </div>

            <!-- <div class="mt-2 text-sm">
              <p class="font-medium">Comentarios</p>
              <p>{{ meal.comments }}</p>
            </div> -->

            <button v-if="addPrint" class="secondary-button mt-4 ml-0">
              Imprimir Etiqueta Manualmente
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Diet Detail",

  props: {
    index: Number,
    mealSet: Object,
    editEnabled: false,
    addPrint: Boolean,
  },

  methods: {
    integerToCurrency(amount) {
      if (amount == null) {
        return "-";
      }

      const formatter = new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN",
        minimumFractionDigits: 2,
      });

      return formatter.format(amount);
    },
  },
};
</script>